import astrazenecaThumb from '../assets/projects/astrazeneca/astrazeneca-thumbnail-1.webp';
import ubitricityThumb from '../assets/projects/ubitricity/ubitricity-thumbnail-1.webp';
import evositeThumb from '../assets/projects/evo-agency/evosite-img-1.webp';
import dstilleryThumb from '../assets/projects/dstillery/dstillery-thumbnail-1.webp';
import varietalThumb from '../assets/projects/varietal/varietal-thumbnail.webp';
import contrastThumb from '../assets/projects/contrast/contrast-security-thumbnail.webp';
import pharmaThumb from '../assets/projects/healthcare/Microscope.gif';
import travelperkPoster from '../assets/projects/travelperk/travelperk-thumbnail-poster.jpg';
import travelperkVideo from '../assets/projects/travelperk/travelperk-thumbnail.mp4';
import keymotionThumb from '../assets/projects/keymotion/keymotion-thumbnail-logo.png';
import adareThumb from '../assets/projects/adare-collection/adare-thumbnail.jpg';

// Curated display order used by the homepage grid.
// Projects flagged `hidden` are kept here (with their assets) but excluded
// from the homepage grid, Selected Work list and the INDEX page. Their
// routes redirect to the homepage (see App.js).
// Desktop masonry: Keymotion + Adare (left), TravelPerk (top-right).
const allProjects = [
  { to: '/keymotion', title: 'Keymotion', img: keymotionThumb, shorter: true },
  { to: '/travelperk', title: 'TravelPerk', img: travelperkPoster, video: travelperkVideo },
  { to: '/adarecollection', title: 'The Adare Collection', img: adareThumb, ratio: '16x9' },
  { to: '/healthcare', title: 'Healthcare', img: pharmaThumb, hideFromIntro: true },
  { to: '/contrastsecurity', title: 'Contrast Security', img: contrastThumb },
  { to: '/astrazeneca', title: 'AstraZeneca', img: astrazenecaThumb, hidden: true },
  { to: '/ubitricity', title: 'Ubitricity', img: ubitricityThumb, hidden: true },
  { to: '/evoagency', title: 'Evo Agency', img: evositeThumb },
  { to: '/dstillery', title: 'Dstillery', img: dstilleryThumb, hideFromIntro: true },
  { to: '/varietal', title: 'Varietal', img: varietalThumb, hideFromIntro: true },
];

const projects = allProjects.filter((project) => !project.hidden);

export const projectsForIntro = projects.filter((project) => !project.hideFromIntro);

export const projectsAlphabetical = [...projects].sort((a, b) =>
  a.title.localeCompare(b.title)
);

export default projects;
